<template>
    <b-card no-body>
        <v-table ref="table" name="fuel-refinery-price" :items-provider="provider" :fields="fields" :buttons="buttons" pagination="server" search :add-callback="createNew"> </v-table>

        <b-modal v-model="modal.show" :title="modal.title" ok-title="Kaydet" ok-only @ok.prevent="save" :busy="modal.busy">
            <form ref="form">
                <div class="mb-1">
                    <label class="form-label">Başlangıç Tarihi</label>
                    <v-validator :errors="errors" parameter="StartDate" :watch="form.StartDate">
                        <v-date-picker v-model="form.StartDate" type="date" placeholder="Tarih seçiniz" value-type="format" format="YYYY-MM-DD" />
                    </v-validator>
                    <small class="text-muted" v-if="!modal.isEdit">* Yeni fiyatın devreye gireceği tarih.</small>
                </div>

                <div class="mb-1">
                    <label class="form-label">Yakıt Tipi</label> <span class="text-danger">*</span>
                    <v-validator :errors="errors" parameter="Type" :watch="form.Type">
                        <v-select-list v-model="form.Type" label="VisibleName" :reduce="(x) => x.VisibleName" placeholder="Yakıt Tipi Seçiniz" :options="fuelTypes" />
                    </v-validator>
                </div>

                <b-row>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Vergisiz Fiyat</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="PriceWithoutTax" :watch="form.PriceWithoutTax">
                                <v-currency-input :value="form.PriceWithoutTax" @update-value="(v) => (form.PriceWithoutTax = v)" />
                            </v-validator>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Vergili Fiyat</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="PriceWithTax" :watch="form.PriceWithTax">
                                <v-currency-input :value="form.PriceWithTax" disabled />
                            </v-validator>
                        </div>
                    </b-col>
                </b-row>
            </form>
        </b-modal>
    </b-card>
</template>

<script>
import { BCard, BModal, BFormInput, BRow, BCol } from "bootstrap-vue";
import FuelStorageApi from "@/api/fuel-storage";
import VDatePicker from "@/components/VDatePicker";
import VValidator from "@/components/VValidator";
import VCurrencyInput from "@/components/VCurrencyInput";
import SystemDataApi from "@/api/system-data";

export default {
    components: {
        BCard,
        BModal,
        BFormInput,
        BRow,
        BCol,
        VDatePicker,
        VValidator,
        VCurrencyInput,
    },
    data() {
        return {
            fields: [
                { name: "Başlangıç Tarihi", key: "StartDateValue", sortable: true, sortKey: "StartDate", tdClass: "w-20 text-nowrap" },
                { name: "Bitiş Tarihi", key: "EndDateValue", sortable: true, sortKey: "EndDate", tdClass: "w-20 text-nowrap" },
                { name: "Tip", key: "Type", sortable: true, sortKey: "Type", tdClass: "w-20 text-nowrap" },
                { name: "Vergisiz Fiyat [TL]", key: "PriceWithoutTaxFormatted", sortable: true, sortKey: "PriceWithoutTax", tdClass: "w-20 text-nowrap text-right" },
                { name: "Vergili Fiyat [TL]", key: "PriceWithTaxFormatted", sortable: true, sortKey: "PriceWithTax", tdClass: "w-20 text-nowrap text-right" },
            ],
            buttons: [
                {
                    text: "Düzenle",
                    icon: "EditIcon",
                    variant: "primary",
                    disabled: (item) => item.EndDate !== null,
                    action: (item) => this.edit(item),
                },
                {
                    text: "Sil",
                    icon: "TrashIcon",
                    variant: "danger",
                    action: (item) => this.remove(item),
                },
            ],
            modal: {
                show: false,
                title: "Yeni Rafineri Fiyatı",
                busy: false,
                isEdit: false,
            },
            form: {
                Id: null,
                StartDate: null,
                Type: "",
                PriceWithoutTax: null,
                PriceWithTax: null,
            },
            errors: {},
            fuelTypes: [],
        };
    },
    created() {
        this.loadFuelTypes();
    },
    watch: {
        "form.PriceWithoutTax"(val) {
            this.form.PriceWithTax = val ? val * 1.2 : 0;
        },
    },
    methods: {
        async provider(data) {
            const response = await FuelStorageApi.FuelStorageRefineryPrice.Table(data);

            if (response.data?.Data?.Data) {
                response.data.Data.Data = response.data.Data.Data.map((item) => {
                    return {
                        ...item,
                        EndDateValue: item.EndDateValue || "-",
                        PriceWithoutTaxFormatted: this.formatCurrency(item.PriceWithoutTax),
                        PriceWithTaxFormatted: this.formatCurrency(item.PriceWithTax),
                    };
                });
            }
            return response;
        },
        async loadFuelTypes() {
            try {
                const response = await SystemDataApi.FuelType(true);
                if (response.data.Success) {
                    this.fuelTypes = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading fuel types:", error);
            }
        },
        createNew() {
            this.resetForm();
            this.modal.isEdit = false;
            this.modal.title = "Yeni Rafineri Fiyatı";
            this.modal.show = true;
        },
        edit(item) {
            let formattedDate = item.StartDate;
            if (item.StartDate && item.StartDate.includes("T")) {
                formattedDate = item.StartDate.split("T")[0];
            }

            this.form = {
                ...item,
                StartDate: formattedDate,
            };
            this.errors = {};
            this.modal.isEdit = true;
            this.modal.title = "Fiyat Düzenle";
            this.modal.show = true;
        },
        save() {
            this.errors = {};

            if (!this.form.StartDate) this.$set(this.errors, "StartDate", "Başlangıç tarihi zorunludur.");
            if (!this.form.Type) this.$set(this.errors, "Type", "Tip alanı zorunludur.");
            if (!this.form.PriceWithoutTax) this.$set(this.errors, "PriceWithoutTax", "Vergisiz fiyat zorunludur.");
            if (!this.form.PriceWithTax) this.$set(this.errors, "PriceWithTax", "Vergili fiyat zorunludur.");

            if (Object.keys(this.errors).length > 0) return;

            this.modal.busy = true;

            FuelStorageApi.FuelStorageRefineryPrice.CreateOrUpdate(this.modal.isEdit, this.form)
                .then((res) => {
                    if (res.data.Success) {
                        this.$refs.table.refresh();
                        this.modal.show = false;
                        this.$toast.success(res.data.Message);
                    } else {
                        this.$toast.error(res.data.Message);
                    }
                })
                .catch((err) => {
                    this.$toast.error("İşlem sırasında hata oluştu.");
                })
                .finally(() => {
                    this.modal.busy = false;
                });
        },
        remove(item) {
            this.$confirm("Silmek istediğinize emin misiniz?", `Bu işlem geri alınamaz.`).then((res) => {
                if (res) {
                    this.$refs.table.rowLoading(true);
                    FuelStorageApi.FuelStorageRefineryPrice.Delete(item.Id)
                        .then((res) => {
                            this.$result(res);
                            if (res.data.Success) {
                                this.$refs.table.refresh();
                            }
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        })
                        .finally(() => {
                            this.$refs.table.rowLoading(false);
                        });
                }
            });
        },
        resetForm() {
            this.form = {
                Id: null,
                StartDate: new Date().toISOString().split("T")[0],
                Type: "",
                PriceWithoutTax: null,
                PriceWithTax: null,
            };
            this.errors = {};
        },
        formatCurrency(value) {
            if (!value) return "0,00";
            return new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
        },
    },
};
</script>

<style scoped>
.card {
    overflow-x: auto;
}
</style>
